<div class="flex h-full w-full flex-col content-center items-center space-y-4">
  <span class="w-full pb-4 text-center text-3xl font-semibold text-white">{{
    'Modifica la tua password' | siaTranslate
  }}</span>
  <form
    [formGroup]="loginForm"
    class="auth-form"
    id="authForm"
    (ngSubmit)="restore()"
  >
    <mat-form-field class="sia-login w-full" appearance="outline">
      <mat-label>{{ 'Username o Email' | siaTranslate }}</mat-label>
      <input
        matInput
        id="userIdentifier"
        formControlName="userIdentifier"
        type="text"
        autocomplete="username"
      />
    </mat-form-field>

    <mat-form-field
      class="sia-login mb-1 w-full"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      <mat-label>Password</mat-label>
      <input
        class="auth-input"
        matInput
        [type]="hidePwd() ? 'password' : 'text'"
        id="password"
        formControlName="password"
        autocomplete="new-password"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="passwordToggle($event)"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hidePwd()"
      >
        <mat-icon>{{ hidePwd() ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
    </mat-form-field>

    <span
      class="flex gap-x-1"
      [class]="
        loginForm.controls['password'].hasError('required') ||
        loginForm.controls['password'].hasError('minlength')
          ? 'text-danger'
          : 'text-success'
      "
    >
      <i class="material-icons text">{{
        loginForm.controls['password'].hasError('required') ||
        loginForm.controls['password'].hasError('minlength')
          ? 'cancel'
          : 'check_circle'
      }}</i>
      {{ 'Almeno 8 caratteri!' | siaTranslate }}
    </span>
    <span
      class="flex gap-x-1"
      [class]="
        loginForm.controls['password'].hasError('required') ||
        loginForm.controls['password'].hasError('hasNumber')
          ? 'text-danger'
          : 'text-success'
      "
    >
      <i class="material-icons text">{{
        loginForm.controls['password'].hasError('required') ||
        loginForm.controls['password'].hasError('hasNumber')
          ? 'cancel'
          : 'check_circle'
      }}</i>
      {{ 'Almeno un numero!' | siaTranslate }}
    </span>
    <span
      class="mb-5 flex gap-x-1"
      [class]="
        loginForm.controls['password'].hasError('required') ||
        loginForm.controls['password'].hasError('hasSpecialCharacters')
          ? 'text-danger'
          : 'text-success'
      "
    >
      <i class="material-icons text">{{
        loginForm.controls['password'].hasError('required') ||
        loginForm.controls['password'].hasError('hasSpecialCharacters')
          ? 'cancel'
          : 'check_circle'
      }}</i>
      {{ 'Almeno un carattere speciale!' | siaTranslate }}
    </span>
    <mat-form-field
      class="sia-login mb-1 w-full"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      <mat-label>{{ 'Ripeti password' | siaTranslate }}</mat-label>
      <input
        class="auth-input"
        matInput
        [type]="hideRepeatPwd() ? 'password' : 'text'"
        id="repeatPassword"
        formControlName="repeatPassword"
        autocomplete="new-password"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="passwordRepeatToggle($event)"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hideRepeatPwd()"
      >
        <mat-icon>{{
          hideRepeatPwd() ? 'visibility' : 'visibility_off'
        }}</mat-icon>
      </button>
    </mat-form-field>
    <span
      class="flex gap-x-1"
      [class]="
        loginForm.controls['repeatPassword'].hasError('NoPassswordMatch')
          ? 'text-danger'
          : 'text-success'
      "
    >
      <i class="material-icons text">{{
        loginForm.controls['repeatPassword'].hasError('NoPassswordMatch')
          ? 'cancel'
          : 'check_circle'
      }}</i>
      {{ 'Password corrispondenti!' | siaTranslate }}
    </span>
    <button
      mat-flat-button
      [disabled]="loginForm.invalid"
      class="secondary mt-4 w-full"
      type="submit"
    >
      {{ 'Imposta password' | siaTranslate }}
    </button>
  </form>

  <div class="auth-info">
    <button
      mat-button
      [style]="{ color: 'white !important' }"
      [routerLink]="'/auth/login'"
      appI18n
    >
      {{ 'Login' | siaTranslate }}
    </button>
  </div>
</div>
